class DateUtils {
  constructor(timezone) {
    this.timezone = timezone || 'Europe/Rome';
    this.offset = this.getTimezoneOffset(this.timezone);
  }

  /**
   * @param {string} strDate
   */
  getDate(strDate) {
    const [month, day, year, time, meridiem] = strDate.split(/[\s,]+/);

    let [hours, minutes] = time.split(":").map(Number);
    if (meridiem === "PM" && hours < 12) hours += 12;
    if (meridiem === "AM" && hours === 12) hours = 0;


    const monthIndex = new Date(`${month} 1, 2000`).getMonth();
    
    return new Date(Date.UTC(
      parseInt(year),
      monthIndex,
      parseInt(day),
      (hours - this.offset),
      minutes,
      0
    ));
  }

  getTimezoneOffset(timezone = 'Europe/Rome', date = new Date()) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'longOffset',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });

    const formattedString = formatter.format(date);
    
    const offsetMatch = formattedString.match(/GMT([+-]\d+)/);
    if (offsetMatch && offsetMatch[1]) {
      return parseInt(offsetMatch[1], 10);
    }
    
    return 0;
  }

  getCurrentUTCDate(time = new Date()) {
    return new Date(Date.UTC(
      time.getUTCFullYear(),
      time.getUTCMonth(),
      time.getUTCDate(),
      time.getUTCHours(),
      time.getUTCMinutes(),
      time.getUTCSeconds()
    ));
  }


  /**
   * @param {{ [x: string]: any; days?: string; hours?: string; minutes?: string; seconds?: any; }} timeObj
   */
  getTimeString(timeObj) {
    return (
      Object.keys(timeObj)
        .map((unit) => (timeObj[unit] !== '00' ? `${timeObj[unit]}` : ''))
        .filter(Boolean)
        .join(':') + (timeObj.seconds === '00' ? `:${timeObj.seconds}` : '')
    );
  }

  /**
   * @param {number} ms
   */
  getTimeObjFromMS(ms) {
    return {
      days: String(Math.floor(ms / (1000 * 60 * 60 * 24))).padStart(2, '0'),
      hours: String(Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
      minutes: String(Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
      seconds: String(Math.floor((ms % (1000 * 60)) / 1000)).padStart(2, '0'),
    };
  }

}



class VideoPage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dateUtils = new DateUtils(this.dataset.countdownTimezone);
    this.videoPage = this.querySelector('[data-video-page]');
    this.continue = this.querySelector('[data-continue]');
    this.counter = this.querySelector('[data-counter]');
    this.handleCounter();
    this.setListeners();
  }

  setListeners() {
    this.continue?.addEventListener('click', () => this.classList.add('hidden') );
  }

  handleShowVideo() {
    if (!this.videoPage) return;
    this.videoPage.setAttribute('data-active', 'true');
    this.counterIntervalId && clearInterval(this.counterIntervalId);
  }


  /**
   * @param {number | Date} countDownDate
   */
  changeWebDrawCounter(countDownDate) {
    if (!this.counter) return;
    
    const currentDate = this.dateUtils.getCurrentUTCDate();
    const differenceMs = countDownDate - currentDate;

    if (Math.sign(differenceMs) === -1) {
      this.handleShowVideo()
      return;
    }

    const timeObj = this.dateUtils.getTimeObjFromMS(parseInt(differenceMs));
    const times = this.dateUtils.getTimeString(timeObj);

    this.counter.innerHTML = times;
  }

  handleCounter() {
    const endDate = this.dataset.customEndDate;

    if (!endDate || !this.counter) {
      this.handleShowVideo();
      return;
    }

    const currentDate = this.dateUtils.getCurrentUTCDate();
    const countDownDate = this.dateUtils.getDate(endDate);

    console.log(currentDate.toUTCString(), countDownDate.toUTCString());

    const differenceMs = countDownDate - currentDate;
    console.log("differenceMs", differenceMs)

    if (Math.sign(differenceMs) === 1) {
      this.changeWebDrawCounter(countDownDate);
      this.counterIntervalId = setInterval(() => {
        this.changeWebDrawCounter(countDownDate);
      }, 1000);
    } else {
      this.handleShowVideo();
    }

  }
}

customElements.define('video-page', VideoPage);